import type { IOption } from 'src/interfaces';

export const addAllOption = (options: IOption[], label = 'All') => {
  return options.length > 1 ? [{ id: '', value: label }, ...options] : options;
};
